import React, { ReactElement } from 'react'
import { Controller, FieldValues } from 'react-hook-form'

import { CheckboxBase } from './CheckboxBase'
import { ControlledCommons } from '../../molecules/input-text/input-text'

interface Props<T extends FieldValues> extends ControlledCommons<T> {
  label?: string | ReactElement
  disable?: boolean
  ref?: any
  active?: any
  inactive?: any
  style?: React.CSSProperties
  className?: string
  onClick?: (state: any) => void
}

export function Checkbox<T extends FieldValues>({
  control,
  rules,
  name,
  label,
  disable = false,
  ref,
  active = true,
  inactive = false,
  style = {},
  className,
  onClick,
}: Props<T>) {
  return (
    <Controller
      control={control}
      rules={rules}
      render={({ field }) => {
        const changeHandler = () =>
          !disable && field.onChange(field.value === active ? inactive : active)
        const props = {
          onChange: () => {
            if (onClick) {
              onClick(field.value === active ? inactive : active)
            }
            changeHandler()
          },
          checked: field.value === active,
          disabled: disable,
          label,
          ref,
          style,
          className,
          name,
        }
        return <CheckboxBase {...props} />
      }}
      name={name}
    />
  )
}
